export const environment = {
  production: false,
  apiUrl: 'https://coveragevalidatorapi-dev-a0dbfvf9dnhnb3ay.westus2-01.azurewebsites.net',
  context: 'dev',
  noFollow: true,
};
